import React from 'react';
import {Button} from "react-bootstrap";
import {useIntl} from "react-intl";
import {Formik} from "formik";
import {useDispatch} from "react-redux";
import {DataItem} from "../../../_common/components/DataItem/DataItem";
import {createProject, editProject} from "../../_redux/projectsActions";

export const ProjectName = ({id, initialName}) => {
  const intl = useIntl();
  const dispatch = useDispatch();
  const fieldLabel = intl.formatMessage({
    id: 'projects-popup-project-name-label', defaultMessage: 'Project name:'
  })
  const buttonLabel = intl.formatMessage({
    id: 'projects-popup-save', defaultMessage: 'Save'
  })

  const handleCreateEditProject = (name) => {
    if (id) {
      dispatch(editProject(id, name))
    } else {
      dispatch(createProject(name));
    }
  };

  return (
    <Formik
      initialValues={{name: initialName || ''}}
      onSubmit={() => {
      }}
      enableReinitialize={true}
    >
      {({values}) => (
        <form className={'mb-2 d-flex align-items-center'}>
          <DataItem
            fieldId={'name'}
            value={values.name}
            sideLabel={fieldLabel}
            sideLabelStyle={'text-dark font-weight-bolder font-size-base mr-5'}
            containerStyle={'d-flex mr-8'}
          />
          <Button
            className={`btn btn-sm custom-send-button`}
            onClick={() => handleCreateEditProject(values.name)}
          >
            {buttonLabel}
          </Button>
        </form>
      )}
    </Formik>
  )
};
